import { useState } from "react";
import { useParams } from "react-router-dom";
import { notificationSupport } from "../notifications.js";
import { Onboarding } from "./Onboarding.js";

/**
 * Where an invite link lands when this browser has no TrueWave account.
 *
 * On iPhone, tapping a link (in WhatsApp, Messages, Mail...) always opens
 * Safari — iOS never hands links to a Home Screen web app, and Safari's
 * storage is separate from the app's, so the invite used to land on a
 * "Create your account" page even for someone who already has TrueWave. So
 * here, instead, the invite is handed over to the app: copy it, open
 * TrueWave from the Home Screen, tap Paste invite.
 */
export function InviteLanding() {
  const { token } = useParams();
  const [showSignup, setShowSignup] = useState(false);
  const [copied, setCopied] = useState(false);
  const inSafariOnIphone = notificationSupport() === "ios-needs-install";

  if (!inSafariOnIphone || showSignup) return <Onboarding />;

  const inviteUrl = `${window.location.origin}/#/add/${token ?? ""}`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="center">
      <div className="card">
        <h1>Open this invite in TrueWave</h1>
        <p>iPhone opens links in Safari, not in the TrueWave app — so hand the invite over:</p>
        <ol className="handoff-steps">
          <li>
            <button className="primary" onClick={() => void copy()}>
              {copied ? "✓ Invite copied" : "Copy invite"}
            </button>
          </li>
          <li>Open <strong>TrueWave</strong> from your Home Screen.</li>
          <li>
            Tap <strong>➕</strong> then <strong>Paste invite</strong>.
          </li>
        </ol>
        <div className="banner">
          Don&apos;t have TrueWave on your Home Screen yet? Tap Share (the square with an arrow) →{" "}
          <em>Add to Home Screen</em>, open it, create your account — then do the steps above.
        </div>
        <button className="ghost" onClick={() => setShowSignup(true)}>
          Use TrueWave here in Safari instead
        </button>
      </div>
    </div>
  );
}
